const cardsCarousel = ( selector ) => {
  // Get Carousel collection
  let elements = document.getElementsByClassName(selector);
  // Check if collection isn't empty
  if (0 === elements.length || !elements) return false;

  Array.prototype.filter.call( elements, element => {
    let carousel = new Glide( element, {
      type: 'slider',
      perView: 2,
      focusAt: 'center',
      rewind: false,
      gap: 0,
      breakpoints: {
        1199: {
          perView: 2,
          focusAt: 0,
        },
        991: {
          erView: 2,
          gap: 10,
        },
        767: {
          perView: 1,
        }
      }
    })
    carousel.mount();
  })
}

// Show the carousel after click the trigger
const showCarousel = (selector) => {
  let trigger = document.querySelectorAll(selector)
  if (trigger) {
    trigger.forEach(element => {
      element.addEventListener( 'click', (event) => {
        event.preventDefault()
        element.style.display = 'none'
        element.nextElementSibling.classList.add('show')
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  showCarousel('.sdc-cards-trigger')
  cardsCarousel('sdc-cards-carousel')
});
